function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var Decimal = require('decimal.js');
var MixinModule = require('./lib/mixinmodule');
var ModTemplate = require('../../lib/templates/modtemplate');
var PeerService = require('saito-js/lib/peer_service')["default"];
var Database = require('./lib/database');
var Api = require('./lib/api');
var formatMixinError = Api.formatMixinError,
  MIXIN_APP_KEY_FIELDS = Api.MIXIN_APP_KEY_FIELDS,
  mixinAppKeystore = Api.mixinAppKeystore,
  mixinAppKeystoreFromEnv = Api.mixinAppKeystoreFromEnv;
var Accounts = require('./lib/accounts');
var Transfers = require('./lib/transfers');
var TransferTesting = require('./lib/testing');
var MigrationService = require('./lib/migration');
var BuySaitoService = require('./lib/buysaito');
var migrationClient = require('./lib/ui/migration/client');
var MixinAdmin = require('./lib/admin/mixin-admin');
var MIXIN_CREDENTIAL_FIELDS = ['user_id', 'full_name', 'session_id', 'tip_key_base64', 'pin_token_base64', 'session_seed', 'session_private_key', 'spend_private_key', 'spend_public_key', 'backed_up'];
var PROVIDER_UNAVAILABLE = "Sorry, payment provider isn't available right now — try again later.";
var Mixin = /*#__PURE__*/function (_ModTemplate) {
  function Mixin(app) {
    var _this;
    _classCallCheck(this, Mixin);
    _this = _callSuper(this, Mixin, [app]);
    _this.name = 'Mixin';
    _this.slug = 'mixin';
    _this.appname = 'Mixin';
    _this.description = 'Adding support for Web3 Crypto transfers on Saito';
    _this.categories = 'Finance Utilities';
    _this.icon = 'fas fa-wallet';
    _this["class"] = 'utility';
    _this.status = 'prod';
    _this.MixinModule = MixinModule;
    _this.credentials = {};
    _this.api_key = null;
    _this.deposit_addresses = [];
    _this.mixin_peer = null;
    _this.buysaito_peer = null;
    _this.available_currencies = [];
    _this.erc_saito = null;
    _this.pending_payments = [];
    _this.purchase_overlay = null;
    _this.main = null;
    _this.styles = ['/mixin/style.css'];
    _this.appSession = null;
    _this.account_created = 0;
    _this.account_creation_promise = null;
    _this.crypto_mods = [];
    _this.transfers = null;
    _this.transfer_timer = null;
    _this.migration = null;
    _this.buysaito = null;
    _this.ADDRESS_RESERVATION_PERIOD_IN_MINUTES = 40;
    _this.wrapped_saito_ticker = 'ERC-SAITO';
    _this.migration_page = null;
    _this.migration_header = null;
    _this.fulfillment_mode = 'local';
    _this.payout_mode = 'local';
    _this.treasury_provider_publickeys = [];
    _this.treasury_delegate_publickeys = [];
    _this.cached_treasury_provider_publickey = '';
    _this.load();
    return _this;
  }

  /**
   * Load the complete Mixin configuration from app.options.mixin into runtime state.
   * This is the only Mixin-module function that reads configuration from options.
   */
  _inherits(Mixin, _ModTemplate);
  return _createClass(Mixin, [{
    key: "load",
    value: function load() {
      var _this$app;
      var stored = (_this$app = this.app) === null || _this$app === void 0 || (_this$app = _this$app.options) === null || _this$app === void 0 ? void 0 : _this$app.mixin;
      var options = stored && _typeof(stored) === 'object' && !Array.isArray(stored) ? stored : {};
      var credentials = {};
      for (var _i = 0, _MIXIN_CREDENTIAL_FIE = MIXIN_CREDENTIAL_FIELDS; _i < _MIXIN_CREDENTIAL_FIE.length; _i++) {
        var field = _MIXIN_CREDENTIAL_FIE[_i];
        if (options[field] !== undefined) {
          credentials[field] = options[field];
        }
      }
      this.credentials = credentials;
      this.account_created = credentials.user_id ? 1 : 0;
      var keystore = mixinAppKeystore(options.api_key);
      this.api_key = keystore || (options.api_key && _typeof(options.api_key) === 'object' && !Array.isArray(options.api_key) ? options.api_key : null);
      this.deposit_addresses = Array.isArray(options.deposit_addresses) ? options.deposit_addresses.map(function (item) {
        return _objectSpread({}, item);
      }) : [];
      var keys = function keys(value) {
        return Array.isArray(value) ? value.map(function (key) {
          return String(key || '').trim();
        }).filter(Boolean) : [];
      };
      this.treasury_provider_publickeys = keys(options.treasury_provider_publickeys);
      this.treasury_delegate_publickeys = keys(options.treasury_delegate_publickeys);
      var migrated = this.migrateLegacyModes(options);
      this.fulfillment_mode = migrated.fulfillment_mode;
      this.payout_mode = migrated.payout_mode;
    }

    /**
     * Persist the complete Mixin runtime configuration to app.options.mixin.
     * This is the only Mixin-module function that writes Mixin options and saveOptions().
     * Writes only fulfillment_mode and payout_mode (not legacy operation_mode/execution_mode).
     */
  }, {
    key: "save",
    value: function save() {
      var _this$app$storage, _this$app$storage$sav;
      if (!this.app) {
        return;
      }
      if (!this.app.options || _typeof(this.app.options) !== 'object' || Array.isArray(this.app.options)) {
        this.app.options = {};
      }
      var next = {};
      for (var _i2 = 0, _MIXIN_CREDENTIAL_FIE2 = MIXIN_CREDENTIAL_FIELDS; _i2 < _MIXIN_CREDENTIAL_FIE2.length; _i2++) {
        var field = _MIXIN_CREDENTIAL_FIE2[_i2];
        if (this.credentials && this.credentials[field] !== undefined) {
          next[field] = this.credentials[field];
        }
      }
      if (this.api_key && _typeof(this.api_key) === 'object' && !Array.isArray(this.api_key)) {
        next.api_key = this.api_key;
      }
      next.deposit_addresses = Array.isArray(this.deposit_addresses) ? this.deposit_addresses.map(function (item) {
        return _objectSpread({}, item);
      }) : [];
      next.fulfillment_mode = this.fulfillment_mode;
      next.payout_mode = this.payout_mode === 'remote' ? 'remote' : 'local';
      next.treasury_provider_publickeys = _toConsumableArray(this.treasury_provider_publickeys || []);
      next.treasury_delegate_publickeys = _toConsumableArray(this.treasury_delegate_publickeys || []);
      this.app.options.mixin = next;
      (_this$app$storage = this.app.storage) === null || _this$app$storage === void 0 || (_this$app$storage$sav = _this$app$storage.saveOptions) === null || _this$app$storage$sav === void 0 || _this$app$storage$sav.call(_this$app$storage);
    }

    /**
     * Map known legacy operation_mode values, or keep an explicit fulfillment_mode as stored.
     * Does not infer modes from execution_mode or delegate key presence.
     */
  }, {
    key: "migrateLegacyModes",
    value: function migrateLegacyModes() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var payout_mode = options.payout_mode === 'remote' ? 'remote' : 'local';
      if (options.fulfillment_mode === 'local' || options.fulfillment_mode === 'remote' || options.fulfillment_mode === 'treasury') {
        return {
          fulfillment_mode: options.fulfillment_mode,
          payout_mode: payout_mode
        };
      }
      var legacy = String(options.operation_mode || '').trim();
      if (legacy === 'local') {
        return {
          fulfillment_mode: 'local',
          payout_mode: 'local'
        };
      }
      if (legacy === 'local_remote') {
        return {
          fulfillment_mode: 'local',
          payout_mode: 'remote'
        };
      }
      if (legacy === 'remote_remote') {
        return {
          fulfillment_mode: 'remote',
          payout_mode: 'remote'
        };
      }
      if (legacy === 'treasury') {
        return {
          fulfillment_mode: 'treasury',
          payout_mode: 'local'
        };
      }
      if (options.fulfillment_mode != null && String(options.fulfillment_mode).trim() !== '') {
        return {
          fulfillment_mode: String(options.fulfillment_mode).trim(),
          payout_mode: payout_mode
        };
      }
      return {
        fulfillment_mode: 'local',
        payout_mode: payout_mode
      };
    }
  }, {
    key: "performsLocalFulfillment",
    value: function performsLocalFulfillment() {
      return this.fulfillment_mode === 'local' || this.fulfillment_mode === 'treasury';
    }
  }, {
    key: "normalizePublicKeyList",
    value: function normalizePublicKeyList(value, label) {
      var list = Array.isArray(value) ? value : [];
      var seen = new Set();
      var keys = [];
      var _iterator = _createForOfIteratorHelper(list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _this$app2;
          var entry = _step.value;
          var key = String(entry || '').trim();
          if (!key) {
            continue;
          }
          if (typeof ((_this$app2 = this.app) === null || _this$app2 === void 0 || (_this$app2 = _this$app2.crypto) === null || _this$app2 === void 0 ? void 0 : _this$app2.isPublicKey) !== 'function' || !this.app.crypto.isPublicKey(key)) {
            throw new Error("".concat(label, " contains an invalid Saito public key."));
          }
          if (seen.has(key)) {
            throw new Error("".concat(label, " contains a duplicate public key."));
          }
          seen.add(key);
          keys.push(key);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return keys;
    }
  }, {
    key: "syncFulfillmentQueue",
    value: function syncFulfillmentQueue() {
      var _this$app3,
        _this2 = this;
      if ((_this$app3 = this.app) !== null && _this$app3 !== void 0 && _this$app3.BROWSER || !this.transfers) {
        return;
      }
      if (this.performsLocalFulfillment()) {
        if (!this.transfer_timer) {
          var _this$transfer_timer$, _this$transfer_timer;
          this.transfers.processTransferQueue()["catch"](function (err) {
            console.error('Mixin transfer queue failed:', err);
          });
          this.transfer_timer = setInterval(function () {
            _this2.transfers.processTransferQueue()["catch"](function (err) {
              console.error('Mixin transfer queue failed:', err);
            });
          }, 10000);
          (_this$transfer_timer$ = (_this$transfer_timer = this.transfer_timer).unref) === null || _this$transfer_timer$ === void 0 || _this$transfer_timer$.call(_this$transfer_timer);
        }
        return;
      }
      clearInterval(this.transfer_timer);
      this.transfer_timer = null;
    }
  }, {
    key: "isHandshakeVerifiedPeer",
    value: function isHandshakeVerifiedPeer(peer) {
      if (!peer) {
        return false;
      }
      try {
        var snapshot = typeof peer.get === 'function' ? peer.get() : null;
        return (snapshot === null || snapshot === void 0 ? void 0 : snapshot.is_verified) === true;
      } catch (err) {
        return false;
      }
    }
  }, {
    key: "configuredTreasuryProviderPublickey",
    value: function configuredTreasuryProviderPublickey() {
      var own = String(this.publicKey || '').trim();
      return (this.treasury_provider_publickeys || []).map(function (key) {
        return String(key || '').trim();
      }).find(function (key) {
        return key && key !== own;
      }) || '';
    }
  }, {
    key: "configuredTreasuryDelegatePublickey",
    value: function configuredTreasuryDelegatePublickey() {
      var _this$treasury_delega;
      return String(((_this$treasury_delega = this.treasury_delegate_publickeys) === null || _this$treasury_delega === void 0 ? void 0 : _this$treasury_delega[0]) || '').trim();
    }
  }, {
    key: "isAuthorizedForwardingPeer",
    value: function isAuthorizedForwardingPeer(peer, expectedPublickey) {
      var expected = String(expectedPublickey || '').trim();
      var key = String((peer === null || peer === void 0 ? void 0 : peer.publicKey) || '').trim();
      return !!expected && !!key && key === expected && this.isHandshakeVerifiedPeer(peer);
    }

    /**
     * Remote fulfillment: forward the original request tx to the configured treasury.
     * Returns 0 when this node should handle the request locally.
     * Returns 1 when the helper has taken responsibility (including unreachable errors).
     */
  }, {
    key: "offersTreasuryBackedServices",
    value: function offersTreasuryBackedServices() {
      return this.fulfillment_mode === 'remote' && !!this.configuredTreasuryProviderPublickey();
    }

    /**
     * Peer authorized to request local fulfillment on this node.
     * treasury: only the verified configured delegate.
     * local: the verified direct requester (browser/buyer).
     */
  }, {
    key: "isAuthorizedFulfillmentPeer",
    value: function isAuthorizedFulfillmentPeer(peer, requesterPublickey) {
      if (this.fulfillment_mode === 'treasury') {
        return this.isAuthorizedForwardingPeer(peer, this.configuredTreasuryDelegatePublickey());
      }
      var from = String(requesterPublickey || '').trim();
      return !!from && (peer === null || peer === void 0 ? void 0 : peer.publicKey) === from && this.isHandshakeVerifiedPeer(peer);
    }
  }, {
    key: "tunnelRequestToTreasury",
    value: function () {
      var _tunnelRequestToTreasury = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(tx, mycallback) {
        var reportUnavailable, configured, provider, live, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(this.fulfillment_mode !== 'remote')) {
                _context.n = 1;
                break;
              }
              return _context.a(2, 0);
            case 1:
              reportUnavailable = function reportUnavailable() {
                if (typeof mycallback === 'function') {
                  mycallback({
                    message: PROVIDER_UNAVAILABLE,
                    err: PROVIDER_UNAVAILABLE
                  });
                }
              };
              configured = this.configuredTreasuryProviderPublickey();
              provider = String(this.cached_treasury_provider_publickey || '').trim();
              if (!provider || provider !== configured) {
                provider = configured;
              }
              if (provider) {
                _context.n = 2;
                break;
              }
              this.cached_treasury_provider_publickey = '';
              reportUnavailable();
              return _context.a(2, 1);
            case 2:
              live = null;
              _context.p = 3;
              _context.n = 4;
              return this.app.network.getPeer(provider);
            case 4:
              live = _context.v;
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              live = null;
            case 6:
              if (!(!live || !this.isHandshakeVerifiedPeer(live))) {
                _context.n = 7;
                break;
              }
              this.cached_treasury_provider_publickey = '';
              reportUnavailable();
              return _context.a(2, 1);
            case 7:
              this.cached_treasury_provider_publickey = provider;
              _context.p = 8;
              _context.n = 9;
              return this.app.network.sendTransactionWithCallback(tx, function (response) {
                var _response$msg;
                var result = response && _typeof(response) === 'object' && response.err && response.msg == null ? response : (_response$msg = response === null || response === void 0 ? void 0 : response.msg) !== null && _response$msg !== void 0 ? _response$msg : response;
                if (typeof mycallback === 'function') {
                  mycallback(result);
                }
              }, provider);
            case 9:
              _context.n = 11;
              break;
            case 10:
              _context.p = 10;
              _t2 = _context.v;
              reportUnavailable();
            case 11:
              return _context.a(2, 1);
          }
        }, _callee, this, [[8, 10], [3, 5]]);
      }));
      function tunnelRequestToTreasury(_x, _x2) {
        return _tunnelRequestToTreasury.apply(this, arguments);
      }
      return tunnelRequestToTreasury;
    }()
    /**
     * Deliver a server→browser payment notice.
     * In treasury mode, relay through the sole configured delegate; otherwise send directly.
     * Kept synchronous so queue processing does not race past the send.
     */
  }, {
    key: "notifyBrowser",
    value: function notifyBrowser(notification_request, notification_data, destination_publickey) {
      var _this$app4, _this$app$network, _this$app$network$sen;
      var destination = String(destination_publickey || '').trim();
      if (!destination || (_this$app4 = this.app) !== null && _this$app4 !== void 0 && _this$app4.BROWSER) {
        return;
      }
      if (this.fulfillment_mode === 'treasury') {
        var _this$app5;
        var delegate = this.configuredTreasuryDelegatePublickey();
        if (delegate && (typeof ((_this$app5 = this.app) === null || _this$app5 === void 0 || (_this$app5 = _this$app5.crypto) === null || _this$app5 === void 0 ? void 0 : _this$app5.isPublicKey) !== 'function' || this.app.crypto.isPublicKey(destination))) {
          try {
            this.app.network.sendRequestAsTransaction('mixin treasury forwarding request', {
              destination_publickey: destination,
              notification_request: notification_request,
              notification_data: notification_data
            }, null, delegate);
            return;
          } catch (err) {
            console.error('Mixin treasury notification relay failed:', err);
          }
        }
      }
      (_this$app$network = this.app.network) === null || _this$app$network === void 0 || (_this$app$network$sen = _this$app$network.sendRequestAsTransaction) === null || _this$app$network$sen === void 0 || _this$app$network$sen.call(_this$app$network, notification_request, notification_data, null, destination);
    }
  }, {
    key: "isSlug",
    value: function isSlug(slug) {
      return slug === this.returnSlug() || slug === 'migration';
    }
  }, {
    key: "shouldAffixCallbackToModule",
    value: function shouldAffixCallbackToModule(modname) {
      if (modname === this.name || modname === 'ERC-SAITO' || modname === 'BEP-SAITO') {
        return 1;
      }
      return 0;
    }
  }, {
    key: "returnServices",
    value: function returnServices() {
      this.services = [];
      var canServe = !!this.appSession || this.offersTreasuryBackedServices();
      if (canServe) {
        var _this$app$modules, _this$app$modules$ret;
        this.services.push(new PeerService(null, 'mixin'));
        var buysaito = (_this$app$modules = this.app.modules) === null || _this$app$modules === void 0 || (_this$app$modules$ret = _this$app$modules.returnModule) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.call(_this$app$modules, 'BuySaito');
        if (!buysaito || buysaito.publicKey === buysaito.authorized_public_key) {
          this.services.push(new PeerService(null, 'buysaito'));
        }
      }
      return this.services;
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, peer) {
        var _this3 = this;
        var service,
          _this$credentials,
          accountHash,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              service = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
              if (service.service === 'buysaito' && this.app.BROWSER) {
                this.buysaito_peer = peer;
                this.app.network.sendRequestAsTransaction('buysaito available currencies', null, function (response) {
                  return _this3.receiveAvailableCurrencies(response);
                }, peer.publicKey);
              }
              if (service.service === 'mixin') {
                console.info('Mixin Module: API online!');
                this.mixin_peer = peer;
                if ((_this$credentials = this.credentials) !== null && _this$credentials !== void 0 && _this$credentials.user_id && !this.credentials.backed_up) {
                  console.info('Need to back up my mixin');
                  accountHash = this.accounts.encryptCredentials(this.credentials, this.publicKey);
                  this.app.network.sendRequestAsTransaction('mixin account backup', {
                    account_hash: accountHash
                  }, function () {
                    _this3.credentials.backed_up = true;
                    _this3.accounts.saveCredentials(_this3.credentials);
                  }, peer.publicKey);
                }
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function onPeerServiceUp(_x3, _x4) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app) {
        var _this$credentials2,
          _this4 = this;
        var SaitoPurchaseOverlay, Main, _this$app$modules2, _this$app$modules2$re, buysaito, buysaitoProvider, _this$transfer_timer$2, _this$transfer_timer2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _superPropGet(Mixin, "initialize", this, 3)([app]);
            case 1:
              this.load();
              this.database = new Database(app, this);
              this.api = new Api();
              this.accounts = new Accounts(app, this);
              if (app.BROWSER) {
                _context3.n = 6;
                break;
              }
              this.api.appKeystore = this.api_key || null;
              this.appSession = this.api.createAppSession();
              _context3.n = 2;
              return this.database.ensureAccountsSchema();
            case 2:
              _context3.n = 3;
              return this.database.ensureTransfersSchema();
            case 3:
              _context3.n = 4;
              return this.database.ensureTreasurySchema();
            case 4:
              _context3.n = 5;
              return this.database.copyLegacyTables();
            case 5:
              this.transfers = new Transfers(app, this);
              this.migration = new MigrationService(app, this);
              this.buysaito = new BuySaitoService(app, this);
            case 6:
              if (!((_this$credentials2 = this.credentials) !== null && _this$credentials2 !== void 0 && _this$credentials2.user_id && this.accounts.areCredentialsDeprecated(this.credentials))) {
                _context3.n = 7;
                break;
              }
              app.options.mixin_legacy = _objectSpread({}, app.options.mixin || {});
              this.credentials = {};
              this.account_created = 0;
              this.save();
              _context3.n = 7;
              return app.wallet.setPreferredCrypto('SAITO', 1);
            case 7:
              this.installCryptos();
              if (app.BROWSER) {
                _context3.n = 8;
                break;
              }
              _context3.n = 8;
              return this.syncDepositAddresses();
            case 8:
              if (app.BROWSER) {
                SaitoPurchaseOverlay = require('./lib/ui/overlays/buysaito-purchase');
                Main = require('./lib/ui/main');
                this.purchase_overlay = new SaitoPurchaseOverlay(app, this);
                this.main = new Main(app, this);
              }
              if (!app.BROWSER) {
                buysaito = (_this$app$modules2 = this.app.modules) === null || _this$app$modules2 === void 0 || (_this$app$modules2$re = _this$app$modules2.returnModule) === null || _this$app$modules2$re === void 0 ? void 0 : _this$app$modules2$re.call(_this$app$modules2, 'BuySaito');
                buysaitoProvider = !buysaito || buysaito.publicKey === buysaito.authorized_public_key;
                console.log('Mixin buysaito service', {
                  app_session: !!this.appSession,
                  transfers: !!this.transfers,
                  fulfillment_mode: this.fulfillment_mode,
                  payout_mode: this.payout_mode,
                  buysaito_provider: buysaitoProvider,
                  advertised: !!(buysaitoProvider && (!!this.appSession || this.offersTreasuryBackedServices()))
                });
              }
              if (!app.BROWSER && this.transfers && this.performsLocalFulfillment()) {
                this.transfers.processTransferQueue()["catch"](function (err) {
                  console.error('Mixin transfer queue failed:', err);
                });
                this.transfer_timer = setInterval(function () {
                  _this4.transfers.processTransferQueue()["catch"](function (err) {
                    console.error('Mixin transfer queue failed:', err);
                  });
                }, 10000);
                (_this$transfer_timer$2 = (_this$transfer_timer2 = this.transfer_timer).unref) === null || _this$transfer_timer$2 === void 0 || _this$transfer_timer$2.call(_this$transfer_timer2);
              }
            case 9:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function initialize(_x5) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app) {
        var tx,
          peer,
          mycallback,
          message,
          _this$buysaito_peer,
          serviceKey,
          _this$mixin_peer,
          _serviceKey,
          _this$mixin_peer2,
          _serviceKey2,
          _this$app6,
          provider,
          data,
          destination,
          notification_request,
          allowed,
          _tx$from,
          from,
          directPeer,
          _data,
          result,
          _tx$from2,
          _from,
          _directPeer,
          _result,
          _message$data,
          _tx$from3,
          _from2,
          _directPeer2,
          _result2,
          _message$data2,
          _require,
          receiveTreasuryPayout,
          _result3,
          _message$data$transac,
          _message$data3,
          _require2,
          receiveStoreWithdrawal,
          embedded,
          withdrawalTx,
          Transaction,
          _result4,
          _tx$from4,
          _from3,
          created,
          _tx$from5,
          _from4,
          _data2,
          _tx$from6,
          _from5,
          _data3,
          row,
          _tx$from7,
          _this$app$modules3,
          _this$app$modules3$re,
          _from6,
          direct_peer,
          delegated_peer,
          buysaito,
          buysaitoProvider,
          authorized_peer,
          can_fulfill,
          accepted,
          _data4,
          _erc,
          currencies,
          erc,
          _iterator2,
          _step2,
          crypto,
          price,
          priced,
          response,
          _response,
          instructions,
          _response2,
          _tx$from8,
          owner,
          _args4 = arguments,
          _t3,
          _t4,
          _t5,
          _t6,
          _t7,
          _t8,
          _t9,
          _t0,
          _t1;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              tx = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : null;
              peer = _args4.length > 2 ? _args4[2] : undefined;
              mycallback = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : null;
              if (!(tx == null)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, 0);
            case 1:
              message = tx.returnMessage();
              if (!(this.app.BROWSER && typeof message.request === 'string' && message.request.startsWith('buysaito '))) {
                _context4.n = 3;
                break;
              }
              // sendRequest addresses the slip to its sender and routes the message to
              // the peer, so a service notice is not isTo(this.publicKey).
              serviceKey = (_this$buysaito_peer = this.buysaito_peer) === null || _this$buysaito_peer === void 0 ? void 0 : _this$buysaito_peer.publicKey;
              if (!(!serviceKey || (peer === null || peer === void 0 ? void 0 : peer.publicKey) !== serviceKey)) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, 0);
            case 2:
              return _context4.a(2, this.receiveBuySaitoReply(tx, message));
            case 3:
              if (!(this.app.BROWSER && message.request === 'migration request')) {
                _context4.n = 5;
                break;
              }
              _serviceKey = (_this$mixin_peer = this.mixin_peer) === null || _this$mixin_peer === void 0 ? void 0 : _this$mixin_peer.publicKey;
              if (!(!_serviceKey || (peer === null || peer === void 0 ? void 0 : peer.publicKey) !== _serviceKey)) {
                _context4.n = 4;
                break;
              }
              return _context4.a(2, 0);
            case 4:
              this.receiveMigrationInstructions(message.data);
              return _context4.a(2, 1);
            case 5:
              if (!(this.app.BROWSER && message.request === 'migration failure')) {
                _context4.n = 7;
                break;
              }
              _serviceKey2 = (_this$mixin_peer2 = this.mixin_peer) === null || _this$mixin_peer2 === void 0 ? void 0 : _this$mixin_peer2.publicKey;
              if (!(tx.isTo(this.publicKey) || _serviceKey2 && (peer === null || peer === void 0 ? void 0 : peer.publicKey) === _serviceKey2)) {
                _context4.n = 6;
                break;
              }
              salert('Uh oh, something went wrong with the automated migration. Please back up your wallet to ensure the security of your tokens and contact the team for a manual resolution.');
              return _context4.a(2, 1);
            case 6:
              return _context4.a(2, 0);
            case 7:
              if (!(!this.app.BROWSER && message.request === 'mixin treasury forwarding request')) {
                _context4.n = 10;
                break;
              }
              provider = this.configuredTreasuryProviderPublickey();
              if (this.isAuthorizedForwardingPeer(peer, provider)) {
                _context4.n = 8;
                break;
              }
              if (mycallback) {
                mycallback({
                  err: 'Unauthorized treasury forwarding request.'
                });
              }
              return _context4.a(2, 1);
            case 8:
              data = message.data || {};
              destination = String(data.destination_publickey || '').trim();
              notification_request = String(data.notification_request || '').trim();
              allowed = new Set(['buysaito payment detected', 'buysaito saito issued', 'buysaito report error', 'migration failure']);
              if (!(!destination || !allowed.has(notification_request) || typeof ((_this$app6 = this.app) === null || _this$app6 === void 0 || (_this$app6 = _this$app6.crypto) === null || _this$app6 === void 0 ? void 0 : _this$app6.isPublicKey) === 'function' && !this.app.crypto.isPublicKey(destination))) {
                _context4.n = 9;
                break;
              }
              if (mycallback) {
                mycallback({
                  err: 'Invalid treasury forwarding request.'
                });
              }
              return _context4.a(2, 1);
            case 9:
              this.app.network.sendRequestAsTransaction(notification_request, data.notification_data, null, destination);
              if (mycallback) {
                mycallback({
                  ok: true
                });
              }
              return _context4.a(2, 1);
            case 10:
              if (!(!this.app.BROWSER && message.request === 'migration request')) {
                _context4.n = 20;
                break;
              }
              _context4.n = 11;
              return this.tunnelRequestToTreasury(tx, mycallback);
            case 11:
              if (!_context4.v) {
                _context4.n = 12;
                break;
              }
              return _context4.a(2, 1);
            case 12:
              from = (_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey;
              directPeer = !!from && (peer === null || peer === void 0 ? void 0 : peer.publicKey) === from && this.isHandshakeVerifiedPeer(peer);
              if (!(!this.isAuthorizedFulfillmentPeer(peer, from) || !this.migration)) {
                _context4.n = 13;
                break;
              }
              return _context4.a(2, 0);
            case 13:
              _data = message.data || {};
              _context4.p = 14;
              if (!(_data.publickey && _data.publickey !== from)) {
                _context4.n = 15;
                break;
              }
              result = {
                error: 'The Saito address must be the key that signed this request'
              };
              _context4.n = 17;
              break;
            case 15:
              _context4.n = 16;
              return this.migration.startMigration(from, _data.ticker);
            case 16:
              result = _context4.v;
            case 17:
              _context4.n = 19;
              break;
            case 18:
              _context4.p = 18;
              _t3 = _context4.v;
              result = {
                error: (_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || String(_t3),
                ticker: _data.ticker
              };
            case 19:
              if (directPeer) {
                this.app.network.sendRequestAsTransaction('migration request', result, null, from);
              }
              if (mycallback) {
                mycallback(result);
              }
              return _context4.a(2, 1);
            case 20:
              if (!(!this.app.BROWSER && message.request === 'migration status')) {
                _context4.n = 27;
                break;
              }
              _context4.n = 21;
              return this.tunnelRequestToTreasury(tx, mycallback);
            case 21:
              if (!_context4.v) {
                _context4.n = 22;
                break;
              }
              return _context4.a(2, 1);
            case 22:
              _from = (_tx$from2 = tx.from) === null || _tx$from2 === void 0 || (_tx$from2 = _tx$from2[0]) === null || _tx$from2 === void 0 ? void 0 : _tx$from2.publicKey;
              _directPeer = !!_from && (peer === null || peer === void 0 ? void 0 : peer.publicKey) === _from && this.isHandshakeVerifiedPeer(peer);
              if (!(!this.isAuthorizedFulfillmentPeer(peer, _from) || !this.migration)) {
                _context4.n = 23;
                break;
              }
              return _context4.a(2, 0);
            case 23:
              _context4.p = 23;
              _context4.n = 24;
              return this.migration.getMigrationStatus(_from, (_message$data = message.data) === null || _message$data === void 0 ? void 0 : _message$data.id);
            case 24:
              _result = _context4.v;
              _context4.n = 26;
              break;
            case 25:
              _context4.p = 25;
              _t4 = _context4.v;
              _result = {
                error: (_t4 === null || _t4 === void 0 ? void 0 : _t4.message) || String(_t4)
              };
            case 26:
              if (_directPeer) {
                this.app.network.sendRequestAsTransaction('migration status', _result, null, _from);
              }
              if (mycallback) {
                mycallback(_result);
              }
              return _context4.a(2, 1);
            case 27:
              if (!(!this.app.BROWSER && message.request === 'migration extend')) {
                _context4.n = 34;
                break;
              }
              _context4.n = 28;
              return this.tunnelRequestToTreasury(tx, mycallback);
            case 28:
              if (!_context4.v) {
                _context4.n = 29;
                break;
              }
              return _context4.a(2, 1);
            case 29:
              _from2 = (_tx$from3 = tx.from) === null || _tx$from3 === void 0 || (_tx$from3 = _tx$from3[0]) === null || _tx$from3 === void 0 ? void 0 : _tx$from3.publicKey;
              _directPeer2 = !!_from2 && (peer === null || peer === void 0 ? void 0 : peer.publicKey) === _from2 && this.isHandshakeVerifiedPeer(peer);
              if (!(!this.isAuthorizedFulfillmentPeer(peer, _from2) || !this.migration)) {
                _context4.n = 30;
                break;
              }
              return _context4.a(2, 0);
            case 30:
              _context4.p = 30;
              _context4.n = 31;
              return this.migration.extendReservation(_from2, (_message$data2 = message.data) === null || _message$data2 === void 0 ? void 0 : _message$data2.id);
            case 31:
              _result2 = _context4.v;
              _context4.n = 33;
              break;
            case 32:
              _context4.p = 32;
              _t5 = _context4.v;
              _result2 = {
                error: (_t5 === null || _t5 === void 0 ? void 0 : _t5.message) || String(_t5)
              };
            case 33:
              if (_directPeer2) {
                this.app.network.sendRequestAsTransaction('migration extend', _result2, null, _from2);
              }
              if (mycallback) {
                mycallback(_result2);
              }
              return _context4.a(2, 1);
            case 34:
              if (!(this.app.BROWSER && message.request === 'migration status')) {
                _context4.n = 35;
                break;
              }
              this.receiveMigrationStatusUpdate(message.data);
              return _context4.a(2, 1);
            case 35:
              if (!(this.app.BROWSER && message.request === 'migration extend')) {
                _context4.n = 36;
                break;
              }
              this.receiveMigrationInstructions(message.data);
              return _context4.a(2, 1);
            case 36:
              if (!(!this.app.BROWSER && message.request === 'mixin-issue-treasury-payout')) {
                _context4.n = 38;
                break;
              }
              _require = require('./lib/treasury'), receiveTreasuryPayout = _require.receiveTreasuryPayout;
              _context4.n = 37;
              return receiveTreasuryPayout(this, tx);
            case 37:
              _result3 = _context4.v;
              if (mycallback) {
                mycallback(_result3);
              }
              if ((_result3 === null || _result3 === void 0 ? void 0 : _result3.request_status) === 'accepted' && this.transfers) {
                this.transfers.processTransferQueue()["catch"](function (err) {
                  console.error('Mixin transfer queue failed:', err);
                });
              }
              return _context4.a(2, 1);
            case 38:
              if (!(!this.app.BROWSER && message.request === 'store-withdrawal')) {
                _context4.n = 44;
                break;
              }
              _context4.n = 39;
              return this.tunnelRequestToTreasury(tx, mycallback);
            case 39:
              if (!_context4.v) {
                _context4.n = 40;
                break;
              }
              return _context4.a(2, 1);
            case 40:
              _require2 = require('./lib/store-withdrawal'), receiveStoreWithdrawal = _require2.receiveStoreWithdrawal;
              embedded = (_message$data$transac = (_message$data3 = message.data) === null || _message$data3 === void 0 ? void 0 : _message$data3.transaction) !== null && _message$data$transac !== void 0 ? _message$data$transac : message.transaction;
              withdrawalTx = tx;
              if (embedded && _typeof(embedded) === 'object') {
                withdrawalTx = embedded;
              } else if (typeof embedded === 'string' && embedded) {
                try {
                  Transaction = require('../../lib/saito/transaction')["default"];
                  withdrawalTx = new Transaction();
                  withdrawalTx.deserialize_from_web(this.app, embedded);
                } catch (err) {
                  withdrawalTx = null;
                }
              }
              if (!withdrawalTx) {
                _context4.n = 42;
                break;
              }
              _context4.n = 41;
              return receiveStoreWithdrawal(this, withdrawalTx, peer);
            case 41:
              _t6 = _context4.v;
              _context4.n = 43;
              break;
            case 42:
              _t6 = {
                err: 'The withdrawal transaction could not be read.'
              };
            case 43:
              _result4 = _t6;
              if (mycallback) {
                mycallback(_result4);
              }
              return _context4.a(2, 1);
            case 44:
              if (!(message.request === 'mixin create account')) {
                _context4.n = 51;
                break;
              }
              _context4.n = 45;
              return this.tunnelRequestToTreasury(tx, mycallback);
            case 45:
              if (!_context4.v) {
                _context4.n = 46;
                break;
              }
              return _context4.a(2, 1);
            case 46:
              _from3 = (_tx$from4 = tx.from) === null || _tx$from4 === void 0 || (_tx$from4 = _tx$from4[0]) === null || _tx$from4 === void 0 ? void 0 : _tx$from4.publicKey;
              if (this.isAuthorizedFulfillmentPeer(peer, _from3)) {
                _context4.n = 47;
                break;
              }
              return _context4.a(2, 0);
            case 47:
              _context4.p = 47;
              _context4.n = 48;
              return this.accounts.createAccount(_from3);
            case 48:
              created = _context4.v;
              if (mycallback) {
                mycallback({
                  res: created.ciphertext,
                  restored: created.restored
                });
              }
              _context4.n = 50;
              break;
            case 49:
              _context4.p = 49;
              _t7 = _context4.v;
              console.error('Mixin Create Account Error', _t7);
              if (mycallback) {
                mycallback({
                  err: formatMixinError(_t7) || 'Mixin create account error'
                });
              }
            case 50:
              return _context4.a(2, 1);
            case 51:
              if (!(message.request === 'mixin save new deposit address')) {
                _context4.n = 56;
                break;
              }
              _context4.n = 52;
              return this.tunnelRequestToTreasury(tx, mycallback);
            case 52:
              if (!_context4.v) {
                _context4.n = 53;
                break;
              }
              return _context4.a(2, 1);
            case 53:
              _from4 = (_tx$from5 = tx.from) === null || _tx$from5 === void 0 || (_tx$from5 = _tx$from5[0]) === null || _tx$from5 === void 0 ? void 0 : _tx$from5.publicKey;
              if (this.isAuthorizedFulfillmentPeer(peer, _from4)) {
                _context4.n = 54;
                break;
              }
              return _context4.a(2, 0);
            case 54:
              _data2 = message.data || {};
              _context4.n = 55;
              return this.database.insertAddress({
                mixinUserId: _data2.user_id,
                publicKey: _data2.publickey,
                assetId: _data2.asset_id,
                address: _data2.address,
                createdAt: tx.timestamp
              });
            case 55:
              if (mycallback) {
                mycallback(true);
              }
              return _context4.a(2, 1);
            case 56:
              if (!(message.request === 'mixin fetch user')) {
                _context4.n = 64;
                break;
              }
              _context4.n = 57;
              return this.tunnelRequestToTreasury(tx, mycallback);
            case 57:
              if (!_context4.v) {
                _context4.n = 58;
                break;
              }
              return _context4.a(2, 1);
            case 58:
              _from5 = (_tx$from6 = tx.from) === null || _tx$from6 === void 0 || (_tx$from6 = _tx$from6[0]) === null || _tx$from6 === void 0 ? void 0 : _tx$from6.publicKey;
              if (this.isAuthorizedFulfillmentPeer(peer, _from5)) {
                _context4.n = 59;
                break;
              }
              return _context4.a(2, 0);
            case 59:
              _data3 = message.data || {};
              if (!(!_data3.asset_id || !_data3.address && !_data3.publicKey && !_data3.user_id)) {
                _context4.n = 60;
                break;
              }
              if (mycallback) {
                mycallback([]);
              }
              return _context4.a(2, 1);
            case 60:
              _context4.p = 60;
              _context4.n = 61;
              return this.database.findAddress({
                assetId: _data3.asset_id,
                mixinUserId: _data3.user_id,
                publicKey: _data3.publicKey,
                address: _data3.address
              });
            case 61:
              row = _context4.v;
              if (mycallback) {
                mycallback(row ? [row] : []);
              }
              _context4.n = 63;
              break;
            case 62:
              _context4.p = 62;
              _t8 = _context4.v;
              console.error(_t8);
              if (mycallback) {
                mycallback([]);
              }
            case 63:
              return _context4.a(2, 1);
            case 64:
              if (!(!this.app.BROWSER && typeof message.request === 'string' && message.request.startsWith('buysaito '))) {
                _context4.n = 87;
                break;
              }
              if (!(message.request === 'buysaito available currencies' || message.request === 'buysaito reserve address' || message.request === 'buysaito release address')) {
                _context4.n = 66;
                break;
              }
              _context4.n = 65;
              return this.tunnelRequestToTreasury(tx, mycallback);
            case 65:
              if (!_context4.v) {
                _context4.n = 66;
                break;
              }
              return _context4.a(2, 1);
            case 66:
              _from6 = (_tx$from7 = tx.from) === null || _tx$from7 === void 0 || (_tx$from7 = _tx$from7[0]) === null || _tx$from7 === void 0 ? void 0 : _tx$from7.publicKey;
              direct_peer = !!_from6 && (peer === null || peer === void 0 ? void 0 : peer.publicKey) === _from6 && this.isHandshakeVerifiedPeer(peer);
              delegated_peer = this.isAuthorizedForwardingPeer(peer, this.configuredTreasuryDelegatePublickey()); // Off-chain requests are routed to the peer, while the transaction's
              // recipient slip remains the buyer. Buyer identity stays tx.from.
              buysaito = (_this$app$modules3 = this.app.modules) === null || _this$app$modules3 === void 0 || (_this$app$modules3$re = _this$app$modules3.returnModule) === null || _this$app$modules3$re === void 0 ? void 0 : _this$app$modules3$re.call(_this$app$modules3, 'BuySaito');
              buysaitoProvider = !buysaito || buysaito.publicKey === buysaito.authorized_public_key;
              authorized_peer = this.isAuthorizedFulfillmentPeer(peer, _from6);
              can_fulfill = !!this.appSession && !!this.transfers && buysaitoProvider;
              accepted = can_fulfill && authorized_peer;
              console.log('Mixin buysaito request', {
                request: message.request,
                app_session: !!this.appSession,
                transfers: !!this.transfers,
                fulfillment_mode: this.fulfillment_mode,
                server: this.publicKey,
                addressed_to_server: tx.isTo(this.publicKey),
                buysaito_provider: buysaitoProvider,
                buyer: _from6 || '',
                connected_peer: (peer === null || peer === void 0 ? void 0 : peer.publicKey) || '',
                direct_peer: direct_peer,
                delegated_peer: delegated_peer,
                accepted: accepted
              });
              if (authorized_peer) {
                _context4.n = 67;
                break;
              }
              return _context4.a(2, 0);
            case 67:
              if (accepted) {
                _context4.n = 68;
                break;
              }
              if (mycallback) {
                mycallback({
                  message: PROVIDER_UNAVAILABLE,
                  err: PROVIDER_UNAVAILABLE
                });
              }
              return _context4.a(2, 1);
            case 68:
              _data4 = message.data || {};
              if (!(message.request === 'buysaito available currencies')) {
                _context4.n = 80;
                break;
              }
              currencies = [];
              erc = null;
              _context4.p = 69;
              _iterator2 = _createForOfIteratorHelper(this.crypto_mods);
              _context4.p = 70;
              _iterator2.s();
            case 71:
              if ((_step2 = _iterator2.n()).done) {
                _context4.n = 74;
                break;
              }
              crypto = _step2.value;
              if (!(!crypto.last_update || Date.now() - crypto.last_update > 300000)) {
                _context4.n = 72;
                break;
              }
              console.log('Mixin buysaito refreshing price', crypto.ticker);
              _context4.n = 72;
              return crypto.returnMixinNetworkInfo();
            case 72:
              price = Number(crypto.price_usd);
              priced = Number.isFinite(price) && price > 0;
              if (crypto.ticker === 'ERC-SAITO') {
                if (priced) {
                  erc = crypto;
                }
              } else if (priced && crypto.ticker && crypto.ticker !== 'BEP-SAITO') {
                currencies.push({
                  ticker: crypto.ticker,
                  chain_id: crypto.chain_id,
                  price_usd: price,
                  last_update: crypto.last_update,
                  icon_url: crypto.icon_url
                });
              }
            case 73:
              _context4.n = 71;
              break;
            case 74:
              _context4.n = 76;
              break;
            case 75:
              _context4.p = 75;
              _t9 = _context4.v;
              _iterator2.e(_t9);
            case 76:
              _context4.p = 76;
              _iterator2.f();
              return _context4.f(76);
            case 77:
              _context4.n = 79;
              break;
            case 78:
              _context4.p = 78;
              _t0 = _context4.v;
              console.log('Mixin buysaito available currencies failed', _t0);
              if (mycallback) {
                mycallback({
                  message: PROVIDER_UNAVAILABLE,
                  err: PROVIDER_UNAVAILABLE
                });
              }
              return _context4.a(2, 1);
            case 79:
              response = {
                ac: currencies,
                erc: Number.isFinite(Number((_erc = erc) === null || _erc === void 0 ? void 0 : _erc.price_usd)) && Number(erc.price_usd) > 0 ? Number(erc.price_usd) : null
              };
              console.log('Mixin buysaito available currencies reply', {
                count: currencies.length,
                tickers: currencies.map(function (currency) {
                  return currency.ticker;
                }),
                erc: response.erc,
                callback: typeof mycallback === 'function',
                buyer: _from6
              });
              if (direct_peer) {
                this.app.network.sendRequestAsTransaction('buysaito available currencies', response, null, _from6);
              }
              if (mycallback) {
                mycallback(response);
              }
              return _context4.a(2, 1);
            case 80:
              if (!(message.request === 'buysaito reserve address')) {
                _context4.n = 85;
                break;
              }
              if (!(!_from6 || _from6 !== (_data4.initiator_publickey || _data4.initiator_pubkey))) {
                _context4.n = 81;
                break;
              }
              _response = {
                message: 'The payment service could not generate a deposit address. Please try again shortly.'
              };
              if (direct_peer) {
                this.app.network.sendRequestAsTransaction('buysaito report error', _response, null, _from6);
              }
              if (mycallback) {
                mycallback(_response);
              }
              return _context4.a(2, 1);
            case 81:
              _context4.p = 81;
              _context4.n = 82;
              return this.buysaito.startPurchase(_from6, _data4);
            case 82:
              instructions = _context4.v;
              if (direct_peer) {
                this.app.network.sendRequestAsTransaction('buysaito reserve address', instructions, null, _from6);
              }
              if (mycallback) {
                mycallback(instructions);
              }
              _context4.n = 84;
              break;
            case 83:
              _context4.p = 83;
              _t1 = _context4.v;
              console.error('BuySaito reservation failed:', _t1);
              _response2 = {
                message: 'The payment service could not generate a deposit address. Please try again shortly.'
              };
              if (direct_peer) {
                this.app.network.sendRequestAsTransaction('buysaito report error', _response2, null, _from6);
              }
              if (mycallback) {
                mycallback({
                  err: _t1.message
                });
              }
            case 84:
              return _context4.a(2, 1);
            case 85:
              if (!(message.request === 'buysaito release address')) {
                _context4.n = 87;
                break;
              }
              if (!(_from6 && _data4.ticker)) {
                _context4.n = 86;
                break;
              }
              _context4.n = 86;
              return this.buysaito.releasePurchaseReservation(_from6, _data4.ticker);
            case 86:
              if (mycallback) {
                mycallback(true);
              }
              return _context4.a(2, 1);
            case 87:
              if (!(message.request === 'mixin account backup')) {
                _context4.n = 93;
                break;
              }
              _context4.n = 88;
              return this.tunnelRequestToTreasury(tx, mycallback);
            case 88:
              if (!_context4.v) {
                _context4.n = 89;
                break;
              }
              return _context4.a(2, 1);
            case 89:
              owner = ((_tx$from8 = tx.from) === null || _tx$from8 === void 0 || (_tx$from8 = _tx$from8[0]) === null || _tx$from8 === void 0 ? void 0 : _tx$from8.publicKey) || '';
              if (this.isAuthorizedFulfillmentPeer(peer, owner)) {
                _context4.n = 90;
                break;
              }
              return _context4.a(2, 0);
            case 90:
              if (owner) {
                _context4.n = 91;
                break;
              }
              if (mycallback) {
                mycallback({
                  err: 'Missing account owner public key.'
                });
              }
              return _context4.a(2, 1);
            case 91:
              _context4.n = 92;
              return this.database.saveCredentials(owner, message.data.account_hash);
            case 92:
              if (mycallback) {
                mycallback();
              }
              return _context4.a(2, 1);
            case 93:
              return _context4.a(2, _superPropGet(Mixin, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee4, this, [[81, 83], [70, 75, 76, 77], [69, 78], [60, 62], [47, 49], [30, 32], [23, 25], [14, 18]]);
      }));
      function handlePeerTransaction(_x6) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "approveManualMigration",
    value: function () {
      var _approveManualMigration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id) {
        var rows, row, payload, signed;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.database.getTransfers({
                id: Number(id)
              });
            case 1:
              rows = _context5.v;
              row = rows === null || rows === void 0 ? void 0 : rows[0];
              if (!(!row || row.purpose !== 'migration' || row.mode !== 'manual')) {
                _context5.n = 2;
                break;
              }
              throw new Error('No manual migration matches that id.');
            case 2:
              if (!(Number(row.excluded) === 1)) {
                _context5.n = 3;
                break;
              }
              throw new Error('That transfer is excluded from processing.');
            case 3:
              if (!row.outbound_tx_sig) {
                _context5.n = 4;
                break;
              }
              return _context5.a(2, row);
            case 4:
              if (!(row.status !== 'inbound_confirmed')) {
                _context5.n = 5;
                break;
              }
              throw new Error('Migration deposit is not confirmed.');
            case 5:
              this.migration.allocationForDeposit(row.outbound_amount);
              payload = {};
              try {
                payload = row.payload ? JSON.parse(row.payload) : {};
              } catch (err) {
                payload = {};
              }
              payload.approved_by = this.publicKey || '';
              payload.approved_at = Date.now();
              _context5.n = 6;
              return this.database.updateTransfer(row.id, {
                payload: JSON.stringify(payload)
              });
            case 6:
              row.payload = JSON.stringify(payload);
              _context5.n = 7;
              return this.transfers.issueOutboundTransfer(row);
            case 7:
              signed = _context5.v;
              _context5.n = 8;
              return this.transfers.rebroadcastSavedOutboundTransfers();
            case 8:
              return _context5.a(2, signed);
          }
        }, _callee5, this);
      }));
      function approveManualMigration(_x7) {
        return _approveManualMigration.apply(this, arguments);
      }
      return approveManualMigration;
    }()
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function onConfirmation() {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "accountSummary",
    value: function accountSummary() {
      var _this$accounts, _this$accounts$getCre;
      var credentials = ((_this$accounts = this.accounts) === null || _this$accounts === void 0 || (_this$accounts$getCre = _this$accounts.getCredentials) === null || _this$accounts$getCre === void 0 ? void 0 : _this$accounts$getCre.call(_this$accounts)) || {};
      if (!credentials.user_id) {
        return null;
      }
      var backup = {
        user_id: credentials.user_id,
        full_name: credentials.full_name || '',
        session_id: credentials.session_id || '',
        tip_key_base64: credentials.tip_key_base64 || '',
        session_seed: credentials.session_seed || '',
        spend_private_key: credentials.spend_private_key || '',
        spend_public_key: credentials.spend_public_key || ''
      };
      return {
        user_id: backup.user_id,
        full_name: backup.full_name,
        backup: JSON.stringify(backup)
      };
    }
  }, {
    key: "restoreAccount",
    value: function restoreAccount(raw) {
      if (this.accountSummary()) {
        throw new Error('A Mixin account is already configured on this server');
      }
      var parsed = raw;
      if (typeof raw === 'string') {
        try {
          parsed = JSON.parse(raw.trim());
        } catch (err) {
          throw new Error('Mixin account backup is not valid JSON');
        }
      }
      if (!parsed || _typeof(parsed) !== 'object' || Array.isArray(parsed)) {
        throw new Error('Mixin account backup must be a JSON object');
      }
      var credentials = {
        user_id: String(parsed.user_id || '').trim(),
        full_name: String(parsed.full_name || ''),
        session_id: String(parsed.session_id || '').trim(),
        tip_key_base64: String(parsed.tip_key_base64 || '').trim(),
        session_seed: String(parsed.session_seed || parsed.session_private_key || '').trim(),
        spend_private_key: String(parsed.spend_private_key || '').trim(),
        spend_public_key: String(parsed.spend_public_key || ''),
        backed_up: true
      };
      var missing = ['user_id', 'session_id', 'tip_key_base64', 'session_seed', 'spend_private_key'].filter(function (name) {
        return !credentials[name];
      });
      if (missing.length) {
        throw new Error("Mixin account backup is incomplete (missing: ".concat(missing.join(', '), ")"));
      }
      this.credentials = credentials;
      this.account_created = 1;
      this.accounts.saveCredentials(credentials);
      return credentials;
    }
  }, {
    key: "depositAddresses",
    value: function depositAddresses() {
      return Array.isArray(this.deposit_addresses) ? this.deposit_addresses : [];
    }
  }, {
    key: "rememberDepositAddress",
    value: function rememberDepositAddress() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        address = _ref.address,
        _ref$assetId = _ref.assetId,
        assetId = _ref$assetId === void 0 ? '' : _ref$assetId,
        _ref$ticker = _ref.ticker,
        ticker = _ref$ticker === void 0 ? '' : _ref$ticker,
        _ref$mixinUserId = _ref.mixinUserId,
        mixinUserId = _ref$mixinUserId === void 0 ? '' : _ref$mixinUserId;
      var value = String(address || '').trim();
      if (!value) {
        return;
      }
      var list = this.depositAddresses().map(function (item) {
        return _objectSpread({}, item);
      });
      var asset = String(assetId || '');
      var existing = list.find(function (item) {
        if (item.address !== value) {
          return false;
        }
        return !asset || !item.asset_id || item.asset_id === asset;
      });
      if (existing) {
        if (asset && !existing.asset_id) {
          existing.asset_id = asset;
        }
        if (ticker && !existing.ticker) {
          existing.ticker = ticker;
        }
        if (mixinUserId && existing.mixin_user_id !== mixinUserId) {
          existing.mixin_user_id = mixinUserId;
        }
        existing.balance = existing.balance || '0';
        existing.credited = Array.isArray(existing.credited) ? existing.credited : [];
      } else {
        list.push({
          address: value,
          asset_id: asset,
          ticker: ticker || '',
          mixin_user_id: mixinUserId || '',
          balance: '0',
          credited: []
        });
      }
      if (JSON.stringify(list) === JSON.stringify(this.depositAddresses())) {
        return;
      }
      this.deposit_addresses = list;
      this.save();
    }
  }, {
    key: "creditDepositAddress",
    value: function creditDepositAddress(address, amount, hash) {
      var value = String(address || '').trim();
      var id = String(hash || '').trim();
      var credit;
      try {
        credit = new Decimal(amount);
      } catch (err) {
        return;
      }
      if (!value || !id || !credit.isFinite() || !credit.greaterThan(0)) {
        return;
      }
      var list = this.depositAddresses().map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          credited: Array.isArray(item.credited) ? item.credited.slice() : []
        });
      });
      var entry = list.find(function (item) {
        return item.address === value;
      });
      if (!entry) {
        entry = {
          address: value,
          asset_id: '',
          ticker: '',
          mixin_user_id: '',
          balance: '0',
          credited: []
        };
        list.push(entry);
      }
      if (entry.credited.includes(id)) {
        return;
      }
      var balance;
      try {
        balance = new Decimal(entry.balance || 0);
      } catch (err) {
        balance = new Decimal(0);
      }
      entry.balance = balance.plus(credit).toFixed(8).replace(/\.?0+$/, '') || '0';
      entry.credited.push(id);
      this.deposit_addresses = list;
      this.save();
    }
  }, {
    key: "syncDepositAddresses",
    value: function () {
      var _syncDepositAddresses = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this$database,
          _this5 = this;
        var rows, _iterator3, _step3, _loop, _t10, _t11;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              if (!(typeof ((_this$database = this.database) === null || _this$database === void 0 ? void 0 : _this$database.listAddresses) !== 'function' || !this.publicKey)) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              rows = [];
              _context8.p = 2;
              _context8.n = 3;
              return this.database.listAddresses(this.publicKey);
            case 3:
              rows = _context8.v;
              _context8.n = 5;
              break;
            case 4:
              _context8.p = 4;
              _t10 = _context8.v;
              return _context8.a(2);
            case 5:
              _iterator3 = _createForOfIteratorHelper(rows || []);
              _context8.p = 6;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var _find;
                var row, ticker;
                return _regenerator().w(function (_context7) {
                  while (1) switch (_context7.n) {
                    case 0:
                      row = _step3.value;
                      if (row !== null && row !== void 0 && row.address) {
                        _context7.n = 1;
                        break;
                      }
                      return _context7.a(2, 1);
                    case 1:
                      ticker = ((_find = (_this5.crypto_mods || []).find(function (item) {
                        return item.asset_id === row.asset_id;
                      })) === null || _find === void 0 ? void 0 : _find.ticker) || '';
                      _this5.rememberDepositAddress({
                        address: row.address,
                        assetId: row.asset_id,
                        ticker: ticker,
                        mixinUserId: row.mixin_user_id
                      });
                    case 2:
                      return _context7.a(2);
                  }
                }, _loop);
              });
              _iterator3.s();
            case 7:
              if ((_step3 = _iterator3.n()).done) {
                _context8.n = 10;
                break;
              }
              return _context8.d(_regeneratorValues(_loop()), 8);
            case 8:
              if (!_context8.v) {
                _context8.n = 9;
                break;
              }
              return _context8.a(3, 9);
            case 9:
              _context8.n = 7;
              break;
            case 10:
              _context8.n = 12;
              break;
            case 11:
              _context8.p = 11;
              _t11 = _context8.v;
              _iterator3.e(_t11);
            case 12:
              _context8.p = 12;
              _iterator3.f();
              return _context8.f(12);
            case 13:
              return _context8.a(2);
          }
        }, _callee7, this, [[6, 11, 12, 13], [2, 4]]);
      }));
      function syncDepositAddresses() {
        return _syncDepositAddresses.apply(this, arguments);
      }
      return syncDepositAddresses;
    }()
  }, {
    key: "depositAddressReport",
    value: function () {
      var _depositAddressReport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this$database2, _this$transfers;
        var reserved, reservationMs, held, _iterator4, _step4, row, address, created, reservedUntil, _t12, _t13;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.n = 1;
              return this.syncDepositAddresses();
            case 1:
              reserved = [];
              if (!(typeof ((_this$database2 = this.database) === null || _this$database2 === void 0 ? void 0 : _this$database2.listReservedInboundAddresses) === 'function')) {
                _context9.n = 4;
                break;
              }
              _context9.n = 2;
              return this.database.listReservedInboundAddresses();
            case 2:
              _t12 = _context9.v;
              if (_t12) {
                _context9.n = 3;
                break;
              }
              _t12 = [];
            case 3:
              reserved = _t12;
            case 4:
              reservationMs = Number(((_this$transfers = this.transfers) === null || _this$transfers === void 0 ? void 0 : _this$transfers.reservation_ms) || Number(this.ADDRESS_RESERVATION_PERIOD_IN_MINUTES || 40) * 60 * 1000);
              held = new Map();
              _iterator4 = _createForOfIteratorHelper(reserved);
              _context9.p = 5;
              _iterator4.s();
            case 6:
              if ((_step4 = _iterator4.n()).done) {
                _context9.n = 10;
                break;
              }
              row = _step4.value;
              if (!(typeof row === 'string')) {
                _context9.n = 7;
                break;
              }
              held.set(row, null);
              return _context9.a(3, 9);
            case 7:
              address = (row === null || row === void 0 ? void 0 : row.inbound_address) || (row === null || row === void 0 ? void 0 : row.address);
              if (address) {
                _context9.n = 8;
                break;
              }
              return _context9.a(3, 9);
            case 8:
              created = Number(row.created_at);
              reservedUntil = Number.isFinite(created) && created > 0 && reservationMs > 0 ? created + reservationMs : null;
              held.set(address, reservedUntil);
            case 9:
              _context9.n = 6;
              break;
            case 10:
              _context9.n = 12;
              break;
            case 11:
              _context9.p = 11;
              _t13 = _context9.v;
              _iterator4.e(_t13);
            case 12:
              _context9.p = 12;
              _iterator4.f();
              return _context9.f(12);
            case 13:
              return _context9.a(2, this.depositAddresses().map(function (item) {
                return {
                  address: item.address,
                  asset_id: item.asset_id || '',
                  ticker: item.ticker || '',
                  mixin_user_id: item.mixin_user_id || '',
                  balance: item.balance || '0',
                  reservable: !held.has(item.address),
                  reserved_until: held.has(item.address) ? held.get(item.address) : null
                };
              }));
          }
        }, _callee8, this, [[5, 11, 12, 13]]);
      }));
      function depositAddressReport() {
        return _depositAddressReport.apply(this, arguments);
      }
      return depositAddressReport;
    }()
  }, {
    key: "mixinApiKeyConfigured",
    value: function mixinApiKeyConfigured() {
      return !!(mixinAppKeystoreFromEnv() || mixinAppKeystore(this.api_key));
    }
  }, {
    key: "saveMixinApiKey",
    value: function saveMixinApiKey(raw) {
      if (mixinAppKeystoreFromEnv()) {
        throw new Error('The Mixin API key is already supplied by the server environment');
      }
      var parsed = raw;
      if (typeof raw === 'string') {
        try {
          parsed = JSON.parse(raw.trim());
        } catch (err) {
          throw new Error('Mixin API key is not valid JSON');
        }
      }
      if (!parsed || _typeof(parsed) !== 'object' || Array.isArray(parsed)) {
        throw new Error('Mixin API key must be a JSON object');
      }
      var missing = MIXIN_APP_KEY_FIELDS.filter(function (field) {
        return typeof parsed[field] !== 'string' || !parsed[field].trim();
      });
      if (missing.length) {
        throw new Error("Mixin API key is incomplete (missing: ".concat(missing.join(', '), ")"));
      }
      var keystore = mixinAppKeystore(parsed);
      this.api_key = keystore;
      this.save();
      if (this.api) {
        this.api.appKeystore = keystore;
        this.appSession = this.api.createAppSession();
      }
    }
  }, {
    key: "respondTo",
    value: function respondTo() {
      var _this6 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      if (type === 'admin-config') {
        var testing = new TransferTesting(this.app, this);
        var getConfig = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
            var request,
              fulfillment_mode,
              payout_mode,
              treasury_provider_publickeys,
              treasury_delegate_publickeys,
              api_key_configured,
              listed,
              _args0 = arguments,
              _t14,
              _t15,
              _t16,
              _t17,
              _t18,
              _t19,
              _t20,
              _t21,
              _t22;
            return _regenerator().w(function (_context0) {
              while (1) switch (_context0.n) {
                case 0:
                  request = _args0.length > 0 && _args0[0] !== undefined ? _args0[0] : {};
                  fulfillment_mode = _this6.fulfillment_mode;
                  payout_mode = _this6.payout_mode === 'remote' ? 'remote' : 'local';
                  treasury_provider_publickeys = _toConsumableArray(_this6.treasury_provider_publickeys || []);
                  treasury_delegate_publickeys = _toConsumableArray(_this6.treasury_delegate_publickeys || []);
                  api_key_configured = _this6.mixinApiKeyConfigured();
                  if (api_key_configured) {
                    _context0.n = 1;
                    break;
                  }
                  return _context0.a(2, {
                    transfers: [],
                    total: 0,
                    page: 1,
                    page_size: 20,
                    account: _this6.accountSummary(),
                    api_key_configured: false,
                    fulfillment_mode: fulfillment_mode,
                    payout_mode: payout_mode,
                    treasury_provider_publickeys: treasury_provider_publickeys,
                    treasury_delegate_publickeys: treasury_delegate_publickeys
                  });
                case 1:
                  _context0.n = 2;
                  return testing.listOutstandingTransfers({
                    search: request.search || '',
                    page: request.page || 1,
                    purpose: request.purpose || ''
                  });
                case 2:
                  listed = _context0.v;
                  _t14 = _objectSpread;
                  _t15 = _objectSpread({}, listed);
                  _t16 = {};
                  _t17 = _this6.accountSummary();
                  _context0.n = 3;
                  return _this6.depositAddressReport();
                case 3:
                  _t18 = _context0.v;
                  _t19 = fulfillment_mode;
                  _t20 = payout_mode;
                  _t21 = treasury_provider_publickeys;
                  _t22 = treasury_delegate_publickeys;
                  return _context0.a(2, _t14(_t15, _t16, {
                    account: _t17,
                    api_key_configured: true,
                    deposit_addresses: _t18,
                    fulfillment_mode: _t19,
                    payout_mode: _t20,
                    treasury_provider_publickeys: _t21,
                    treasury_delegate_publickeys: _t22
                  }));
              }
            }, _callee9);
          }));
          return function getConfig() {
            return _ref2.apply(this, arguments);
          };
        }();
        return {
          id: this.returnSlug(),
          name: this.name,
          getConfig: getConfig,
          updateConfig: function () {
            var _updateConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
              var config,
                fulfillment_mode,
                payout_mode,
                supported,
                providers,
                delegates,
                own,
                usable,
                created,
                _args1 = arguments;
              return _regenerator().w(function (_context1) {
                while (1) switch (_context1.n) {
                  case 0:
                    config = _args1.length > 0 && _args1[0] !== undefined ? _args1[0] : {};
                    if (!(config.action === 'save-api-key')) {
                      _context1.n = 1;
                      break;
                    }
                    _this6.saveMixinApiKey(config.api_key);
                    return _context1.a(2, getConfig(config));
                  case 1:
                    if (!(config.action === 'save-config')) {
                      _context1.n = 8;
                      break;
                    }
                    fulfillment_mode = String(config.fulfillment_mode || '').trim();
                    payout_mode = config.payout_mode === 'remote' ? 'remote' : 'local';
                    supported = fulfillment_mode === 'local' && (payout_mode === 'local' || payout_mode === 'remote') || fulfillment_mode === 'remote' && payout_mode === 'remote' || fulfillment_mode === 'treasury' && payout_mode === 'local';
                    if (supported) {
                      _context1.n = 2;
                      break;
                    }
                    throw new Error('Unsupported fulfillment_mode and payout_mode combination.');
                  case 2:
                    providers = [];
                    delegates = [];
                    own = String(_this6.publicKey || '').trim();
                    if (!(fulfillment_mode === 'local' && payout_mode === 'local')) {
                      _context1.n = 3;
                      break;
                    }
                    providers = [];
                    delegates = [];
                    _context1.n = 7;
                    break;
                  case 3:
                    if (!(fulfillment_mode === 'treasury' && payout_mode === 'local')) {
                      _context1.n = 6;
                      break;
                    }
                    providers = [];
                    delegates = _this6.normalizePublicKeyList(config.treasury_delegate_publickeys, 'Treasury delegate keys');
                    if (!(delegates.length !== 1)) {
                      _context1.n = 4;
                      break;
                    }
                    throw new Error('Treasury mode requires exactly one authorized delegate public key.');
                  case 4:
                    if (!(own && delegates[0] === own)) {
                      _context1.n = 5;
                      break;
                    }
                    throw new Error('The treasury delegate public key must not be this server.');
                  case 5:
                    _context1.n = 7;
                    break;
                  case 6:
                    providers = _this6.normalizePublicKeyList(config.treasury_provider_publickeys, 'Treasury provider keys');
                    delegates = [];
                    usable = providers.filter(function (key) {
                      return key !== own;
                    });
                    if (usable.length) {
                      _context1.n = 7;
                      break;
                    }
                    throw new Error('This mode requires at least one valid Treasury provider public key that is not this server.');
                  case 7:
                    _this6.fulfillment_mode = fulfillment_mode;
                    _this6.payout_mode = payout_mode;
                    _this6.treasury_provider_publickeys = providers;
                    _this6.treasury_delegate_publickeys = delegates;
                    _this6.save();
                    _this6.syncFulfillmentQueue();
                    return _context1.a(2, getConfig(config));
                  case 8:
                    if (!(config.action === 'create-account')) {
                      _context1.n = 11;
                      break;
                    }
                    _context1.n = 9;
                    return _this6.createAccount();
                  case 9:
                    created = _context1.v;
                    if (!(created !== null && created !== void 0 && created.err || !_this6.accountSummary())) {
                      _context1.n = 10;
                      break;
                    }
                    throw new Error((created === null || created === void 0 ? void 0 : created.err) || 'Mixin account was not created');
                  case 10:
                    return _context1.a(2, getConfig(config));
                  case 11:
                    if (!(config.action === 'restore-account')) {
                      _context1.n = 12;
                      break;
                    }
                    _this6.restoreAccount(config.account);
                    return _context1.a(2, getConfig(config));
                  case 12:
                    if (!(config.action === 'exclude-transfer')) {
                      _context1.n = 14;
                      break;
                    }
                    _context1.n = 13;
                    return testing.excludeTransfer(config.id);
                  case 13:
                    return _context1.a(2, getConfig(config));
                  case 14:
                    if (!(config.action === 'verify-migration')) {
                      _context1.n = 16;
                      break;
                    }
                    _context1.n = 15;
                    return _this6.migration.confirmManualMigrationDeposit(config.id, config.amount, config.tx_hash);
                  case 15:
                    return _context1.a(2, getConfig(config));
                  case 16:
                    if (!(config.action === 'approve-migration')) {
                      _context1.n = 18;
                      break;
                    }
                    _context1.n = 17;
                    return _this6.approveManualMigration(config.id);
                  case 17:
                    return _context1.a(2, getConfig(config));
                  case 18:
                    _context1.n = 19;
                    return testing.advanceTransfer(config.id, config.action);
                  case 19:
                    return _context1.a(2, getConfig(config));
                }
              }, _callee0);
            }));
            function updateConfig() {
              return _updateConfig.apply(this, arguments);
            }
            return updateConfig;
          }()
        };
      }
      if (type === 'admin-sidebar') {
        if (!this.app.BROWSER) {
          return null;
        }
        return {
          id: 'payments',
          name: 'Payments',
          render: function render() {
            if (!_this6.admin_ui) {
              _this6.admin_ui = new MixinAdmin(_this6.app, _this6);
            }
            _this6.admin_ui.render();
          }
        };
      }
      if (type == 'crypto-logo') {
        var ticker = obj.ticker;
        var _iterator5 = _createForOfIteratorHelper(this.crypto_mods),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var cryptoModule = _step5.value;
            if (ticker == cryptoModule.ticker) {
              if (cryptoModule.respondTo('crypto-logo', obj)) {
                return cryptoModule.respondTo('crypto-logo', obj);
              }
              var logo = {};
              if (cryptoModule.icon_url) {
                logo.img = cryptoModule.icon_url;
                logo.alt_img = "/".concat(ticker.toLowerCase(), "/img/logo.png");
              } else {
                logo.img = "/".concat(ticker.toLowerCase(), "/img/logo.png");
              }
              if (cryptoModule.chain_id !== cryptoModule.asset_id) {
                for (var i = 0; i < this.crypto_mods.length; i++) {
                  if (this.crypto_mods[i].asset_id == cryptoModule.chain_id) {
                    logo.sub_logo = "/".concat(this.crypto_mods[i].ticker.toLowerCase(), "/img/logo.png");
                  }
                }
              }
              return logo;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
      return null;
    }
  }, {
    key: "installCryptos",
    value: function installCryptos() {
      var _this$api,
        _this$api$createAppSe,
        _this7 = this;
      var mixinSelf = this;
      var modules = this.app.modules.respondTo('mixin-crypto');
      // Public asset metadata requires the Mixin application session. Skip the
      // scheduled lookup when unconfigured so browser/Admin startup stays quiet.
      var hasAppSession = !!((_this$api = this.api) !== null && _this$api !== void 0 && (_this$api$createAppSe = _this$api.createAppSession) !== null && _this$api$createAppSe !== void 0 && _this$api$createAppSe.call(_this$api));
      var _loop2 = function _loop2() {
        var cryptoModule = new MixinModule(_this7.app, mixinSelf, modules[i].ticker, modules[i].asset_id, modules[i].chain_id);
        if (modules[i].returnBalance) {
          cryptoModule.returnBalance = modules[i].returnBalance;
        }
        if (_this7.app.BROWSER) {
          if (!_this7.app.browser.returnURLParameter('withdraw')) {
            if (modules[i].name !== modules[i].ticker) {
              console.warn('Installing a ghost crypto module: ', modules[i].name, modules[i].ticker);
              cryptoModule.hide_me = true;
            }
          }
        }
        _this7.crypto_mods.push(cryptoModule);
        _this7.app.modules.mods.push(cryptoModule);
        setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
          return _regenerator().w(function (_context10) {
            while (1) switch (_context10.n) {
              case 0:
                if (!(hasAppSession && typeof (cryptoModule === null || cryptoModule === void 0 ? void 0 : cryptoModule.returnMixinNetworkInfo) === 'function')) {
                  _context10.n = 1;
                  break;
                }
                _context10.n = 1;
                return cryptoModule.returnMixinNetworkInfo();
              case 1:
                _context10.n = 2;
                return cryptoModule.installModule(mixinSelf.app);
              case 2:
                if (!mixinSelf.account_created) {
                  _context10.n = 3;
                  break;
                }
                if (!(cryptoModule.isActivated() || cryptoModule.address)) {
                  _context10.n = 3;
                  break;
                }
                _context10.n = 3;
                return cryptoModule.activate();
              case 3:
                return _context10.a(2);
            }
          }, _callee1);
        })), 250);
      };
      for (var i = 0; i < modules.length; i++) {
        _loop2();
      }
    }
  }, {
    key: "fetchCredentials",
    value: function fetchCredentials() {
      var _this8 = this;
      return new Promise(function (resolve) {
        var settled = false;
        var finish = function finish(res) {
          if (!settled) {
            settled = true;
            clearTimeout(timeout);
            resolve(res);
          }
        };
        var timeout = setTimeout(function () {
          return finish({
            err: 'Mixin account service timed out'
          });
        }, 30000);
        try {
          var _this8$mixin_peer;
          Promise.resolve(_this8.app.network.sendRequestAsTransaction('mixin create account', {}, finish, (_this8$mixin_peer = _this8.mixin_peer) === null || _this8$mixin_peer === void 0 ? void 0 : _this8$mixin_peer.publicKey))["catch"](function (err) {
            return finish({
              err: formatMixinError(err)
            });
          });
        } catch (err) {
          finish({
            err: formatMixinError(err)
          });
        }
      });
    }
  }, {
    key: "createAccount",
    value: function () {
      var _createAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var _this$credentials3,
          _this9 = this;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              if (!(this.account_created && (_this$credentials3 = this.credentials) !== null && _this$credentials3 !== void 0 && _this$credentials3.user_id)) {
                _context12.n = 1;
                break;
              }
              console.warn('You already have a Mixin Account created...');
              return _context12.a(2, {
                keys: this.credentials,
                existing: true
              });
            case 1:
              if (!this.account_creation_promise) {
                _context12.n = 2;
                break;
              }
              return _context12.a(2, this.account_creation_promise);
            case 2:
              this.account_creation_promise = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
                var _response3;
                var privateKey, response, created, _response4, error, keys, _error, _t23, _t24;
                return _regenerator().w(function (_context11) {
                  while (1) switch (_context11.p = _context11.n) {
                    case 0:
                      _context11.n = 1;
                      return _this9.app.wallet.getPrivateKey();
                    case 1:
                      privateKey = _context11.v;
                      if (!_this9.mixin_peer) {
                        _context11.n = 3;
                        break;
                      }
                      console.log('Request remote node to create Mixin User Account', _this9.mixin_peer.publicKey);
                      _context11.n = 2;
                      return _this9.fetchCredentials();
                    case 2:
                      response = _context11.v;
                      _context11.n = 8;
                      break;
                    case 3:
                      if (!_this9.app.BROWSER) {
                        _context11.n = 4;
                        break;
                      }
                      response = {
                        err: 'Mixin account service is unavailable'
                      };
                      _context11.n = 8;
                      break;
                    case 4:
                      console.log('==> Create Mixin User Account on Same Node as API Keys');
                      _context11.p = 5;
                      _context11.n = 6;
                      return _this9.accounts.createAccount(_this9.publicKey);
                    case 6:
                      created = _context11.v;
                      response = {
                        res: created.ciphertext,
                        restored: created.restored
                      };
                      _context11.n = 8;
                      break;
                    case 7:
                      _context11.p = 7;
                      _t23 = _context11.v;
                      response = {
                        err: formatMixinError(_t23)
                      };
                    case 8:
                      if (!(_typeof(response) !== 'object' || !((_response3 = response) !== null && _response3 !== void 0 && _response3.res))) {
                        _context11.n = 9;
                        break;
                      }
                      error = ((_response4 = response) === null || _response4 === void 0 ? void 0 : _response4.err) || 'Mixin account service returned no account';
                      console.error('Mixin Account Error:', error);
                      return _context11.a(2, {
                        err: error
                      });
                    case 9:
                      _context11.p = 9;
                      keys = _this9.accounts.decryptCredentials(response.res, privateKey);
                      if (response.restored) {
                        console.log('Successfully Restored Mixin Account!');
                      } else {
                        console.log('Successfully Created Mixin Account!');
                      }
                      _this9.credentials = keys;
                      _this9.account_created = 1;
                      _this9.accounts.saveCredentials(keys);
                      return _context11.a(2, {
                        keys: keys,
                        restored: !!response.restored
                      });
                    case 10:
                      _context11.p = 10;
                      _t24 = _context11.v;
                      _error = "Unable to decrypt Mixin account: ".concat(formatMixinError(_t24));
                      console.error(_error);
                      return _context11.a(2, {
                        err: _error
                      });
                  }
                }, _callee10, null, [[9, 10], [5, 7]]);
              }))();
              _context12.p = 3;
              _context12.n = 4;
              return this.account_creation_promise;
            case 4:
              return _context12.a(2, _context12.v);
            case 5:
              _context12.p = 5;
              this.account_creation_promise = null;
              return _context12.f(5);
            case 6:
              return _context12.a(2);
          }
        }, _callee11, this, [[3,, 5, 6]]);
      }));
      function createAccount() {
        return _createAccount.apply(this, arguments);
      }
      return createAccount;
    }()
  }, {
    key: "render",
    value: function render() {
      if (!this.browser_active) {
        return;
      }
      if (this.isMigrationRoute()) {
        this.renderMigrationPage();
        return;
      }
      if (this.main) {
        this.main.render();
      }
    }
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var _this0 = this,
        _app$modules,
        _app$modules$returnMo;
      var MainTemplate = require('./lib/ui/main.template');
      var webdir = "".concat(__dirname, "/web");
      var sendPage = function sendPage(res) {
        var card = _this0.social || {
          twitter: '',
          title: 'Buy SAITO',
          url: '/mixin',
          description: _this0.description,
          image: ''
        };
        res.setHeader('Content-type', 'text/html');
        res.charset = 'UTF-8';
        res.send(MainTemplate(app, _this0, app.build_number, card));
      };
      var migrationDocument = require('./lib/ui/migration/document.template');
      expressapp.get(['/migration', '/migration/'], function (req, res) {
        res.setHeader('Content-type', 'text/html');
        res.charset = 'UTF-8';
        res.send(migrationDocument(app.build_number));
      });
      expressapp.get('/' + encodeURI(this.returnSlug()), function (req, res) {
        sendPage(res);
      });

      // The old purchase page lived at /buy. Keep that entry point when BuySaito
      // is not installed to register it itself.
      if (!((_app$modules = app.modules) !== null && _app$modules !== void 0 && (_app$modules$returnMo = _app$modules.returnModule) !== null && _app$modules$returnMo !== void 0 && _app$modules$returnMo.call(_app$modules, 'BuySaito'))) {
        expressapp.get('/buy', function (req, res) {
          sendPage(res);
        });
      }
      expressapp.use('/' + encodeURI(this.returnSlug()), express["static"](webdir));
    }
  }, {
    key: "receiveAvailableCurrencies",
    value: function receiveAvailableCurrencies(response) {
      var data = response !== null && response !== void 0 && response.request ? response.data : response;
      if (!data || data.err) {
        var message = (data === null || data === void 0 ? void 0 : data.message) || (data === null || data === void 0 ? void 0 : data.err) || 'empty reply';
        console.log('Mixin buysaito available currencies error', message);
        this.available_currencies = null;
        if (data !== null && data !== void 0 && data.message || data !== null && data !== void 0 && data.err) {
          this.app.connection.emit('saito-purchase-error-notification', {
            message: data.message || data.err
          });
        }
        this.app.connection.emit('saito-purchase-cryptos');
        return;
      }
      var excluded = new Set(['ERC-SAITO', 'BEP-SAITO']);
      this.available_currencies = Array.isArray(data.ac) ? data.ac.filter(function (currency) {
        var price = Number(currency === null || currency === void 0 ? void 0 : currency.price_usd);
        return (currency === null || currency === void 0 ? void 0 : currency.ticker) && !excluded.has(currency.ticker) && Number.isFinite(price) && price > 0;
      }) : null;
      var ercPrice = Number(data.erc);
      this.erc_saito = Number.isFinite(ercPrice) && ercPrice > 0 ? {
        price_usd: ercPrice
      } : null;
      if (this.browser_active) {
        var _this$purchase_overla;
        (_this$purchase_overla = this.purchase_overlay) === null || _this$purchase_overla === void 0 || _this$purchase_overla.renderAmountPage();
      }
      this.app.connection.emit('saito-purchase-cryptos');
    }
  }, {
    key: "receiveBuySaitoReply",
    value: function receiveBuySaitoReply(tx, message) {
      var _this$buysaito_peer2;
      var peerKey = (_this$buysaito_peer2 = this.buysaito_peer) === null || _this$buysaito_peer2 === void 0 ? void 0 : _this$buysaito_peer2.publicKey;
      if (!peerKey || !tx.isFrom(peerKey)) {
        return 0;
      }
      var data = message.data;
      if (message.request === 'buysaito available currencies') {
        this.receiveAvailableCurrencies(data);
        return 1;
      }
      if (message.request === 'buysaito report error') {
        this.app.connection.emit('saito-purchase-error-notification', data || {});
        return 1;
      }
      if (message.request === 'buysaito reserve address') {
        this.pending_payments.push(data);
        this.app.connection.emit('saito-purchase-address-reserved', data);
        return 1;
      }
      if (message.request === 'buysaito payment detected') {
        var payment = this.pending_payments.find(function (row) {
          return row.id === (data === null || data === void 0 ? void 0 : data.id) && row.address === (data === null || data === void 0 ? void 0 : data.address) && row.ticker === (data === null || data === void 0 ? void 0 : data.ticker);
        });
        if (payment && ['pending', 'confirmed'].includes(data.status)) {
          payment.status = data.status;
          this.app.connection.emit('saito-purchase-payment-detected', data);
        }
        return 1;
      }
      if (message.request === 'buysaito saito issued') {
        var index = this.pending_payments.findIndex(function (row) {
          return row.address === (data === null || data === void 0 ? void 0 : data.address);
        });
        if (index >= 0) {
          this.pending_payments.splice(index, 1);
          this.app.connection.emit('saito-purchase-saito-issued', data);
        }
        return 1;
      }
      return 0;
    }
  }, {
    key: "convertSaitoToOther",
    value: function convertSaitoToOther(amount) {
      var _this$erc_saito, _find2;
      var ticker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var ercPrice = Number((_this$erc_saito = this.erc_saito) === null || _this$erc_saito === void 0 ? void 0 : _this$erc_saito.price_usd);
      var usdPrice = Number((_find2 = (this.available_currencies || []).find(function (currency) {
        return currency.ticker == ticker;
      })) === null || _find2 === void 0 ? void 0 : _find2.price_usd);
      if (!Number.isFinite(amount) || amount <= 0 || !Number.isFinite(ercPrice) || ercPrice <= 0 || !Number.isFinite(usdPrice) || usdPrice <= 0) {
        return NaN;
      }
      var saitoPrice = Math.max(0.001, 1.1 * ercPrice);
      return Math.ceil(amount * saitoPrice / usdPrice * 1000000) / 1000000;
    }
  }, {
    key: "convertToSaito",
    value: function convertToSaito(amount) {
      var _this$erc_saito2, _find3;
      var ticker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var ercPrice = Number((_this$erc_saito2 = this.erc_saito) === null || _this$erc_saito2 === void 0 ? void 0 : _this$erc_saito2.price_usd);
      var usdPrice = Number((_find3 = (this.available_currencies || []).find(function (currency) {
        return currency.ticker == ticker;
      })) === null || _find3 === void 0 ? void 0 : _find3.price_usd);
      if (!Number.isFinite(amount) || amount <= 0 || !Number.isFinite(ercPrice) || ercPrice <= 0 || !Number.isFinite(usdPrice) || usdPrice <= 0) {
        return NaN;
      }
      var saitoPrice = Math.max(0.001, 1.1 * ercPrice);
      return Math.floor(amount * usdPrice / saitoPrice);
    }
  }, {
    key: "onNewBlock",
    value: function () {
      var _onNewBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(block, longestChain) {
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              if (!(!this.app.BROWSER && this.transfers && this.performsLocalFulfillment())) {
                _context13.n = 1;
                break;
              }
              _context13.n = 1;
              return this.transfers.onNewBlock(block, longestChain);
            case 1:
              return _context13.a(2);
          }
        }, _callee12, this);
      }));
      function onNewBlock(_x8, _x9) {
        return _onNewBlock.apply(this, arguments);
      }
      return onNewBlock;
    }()
  }, {
    key: "onChainReorganization",
    value: function () {
      var _onChainReorganization = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(blockId, blockHash, longestChain) {
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              if (!(!this.app.BROWSER && this.transfers && this.performsLocalFulfillment())) {
                _context14.n = 1;
                break;
              }
              _context14.n = 1;
              return this.transfers.onChainReorganization(blockId, blockHash, longestChain);
            case 1:
              return _context14.a(2);
          }
        }, _callee13, this);
      }));
      function onChainReorganization(_x0, _x1, _x10) {
        return _onChainReorganization.apply(this, arguments);
      }
      return onChainReorganization;
    }()
  }, {
    key: "destroy",
    value: function destroy(app) {
      clearInterval(this.transfer_timer);
      this.transfer_timer = null;
      _superPropGet(Mixin, "destroy", this, 3)([app]);
    }
  }, {
    key: "fetchMixinUser",
    value: function fetchMixinUser(query) {
      var _this1 = this;
      if (this.app.BROWSER) {
        return new Promise(function (resolve) {
          var _this1$mixin_peer;
          _this1.app.network.sendRequestAsTransaction('mixin fetch user', query, function (res) {
            resolve(Array.isArray(res) && res.length ? res[0] : null);
          }, (_this1$mixin_peer = _this1.mixin_peer) === null || _this1$mixin_peer === void 0 ? void 0 : _this1$mixin_peer.publicKey);
        });
      }
      return this.database.findAddress({
        assetId: query.asset_id,
        mixinUserId: query.user_id,
        publicKey: query.publicKey,
        address: query.address
      });
    }
  }]);
}(ModTemplate);
Object.assign(Mixin.prototype, migrationClient);
module.exports = Mixin;